<template>
  <b-row>
    <b-col
      cols="12"
      md="4"
      sm="4"
      class="form-inline justify-content-center justify-content-sm-start mb-2 mb-sm-0"
    >
      <p class="mb-0 p-gray text-nowrap">
        Showing
        <span id="from-row">{{
          rows == 0 ? 0 : ((filter.page - 1) * filter.take + 1) | numeral("0,0")
        }}</span>
        to
        <span id="to-row">
          {{
            filter.take * filter.page > rows
              ? rows
              : (filter.take * filter.page) | numeral("0,0")
          }}</span
        >
        of <span id="total-row">{{ rows | numeral("0,0") }}</span> entires
      </p>
    </b-col>
    <b-col
      cols="12"
      md="8"
      sm="8"
      class="form-inline justify-content-center justify-content-sm-end"
    >
      <b-pagination
        v-model="filter.page"
        :total-rows="rows"
        :per-page="filter.take"
        @change="$emit('pagination', $event)"
        first-text="First"
        prev-text="Prev"
        next-text="Next"
        last-text="Last"
        class="mb-0"
      ></b-pagination>
      <div class="break"></div>
      <div class="mt-2 mt-sm-0 ml-0 ml-sm-1">
        <b-form-select
          class="page-take"
          v-model="filter.take"
          @change="$emit('handleChangeTake', $event)"
          :options="pageOptions"
        ></b-form-select>
      </div>
    </b-col>
  </b-row>
</template>
<script>
export default {
  props: {
    filter: {
      required: true,
      type: Object,
    },
    pageOptions: {
      required: false,
      type: Array,
    },
    handleChangeTake: {
      required: false,
    },
    rows: {
      required: false,
    },
    pagination: {
      required: false,
    },
  },
};
</script>
<style lang="css">
@media only screen and (max-width: 820px) and (min-width: 415px) {
  .page-take {
    max-width: 60px;
  }
}
@media only screen and (max-width: 414px) {
  .break {
    flex-basis: 100%;
    height: 0;
  }
}
</style>
